
import { ArrowRight } from 'lucide-react';
const CTASection = () => {
  return <section id="cta-section" className="bg-gradient-to-br from-indigo-50 to-purple-100 py-20">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-cs-dark-grey mb-6">Close your critical reqs before they become emergencies</h2>
          <p className="text-xl md:text-2xl text-cs-dark-grey mb-10">Get the speed with quality like you should get in 2025. Else $250 is on us.</p>
          
          <div className="flex justify-center">
            <a href="https://cutshort.io/a/cxo-abm" target="_blank" rel="noopener noreferrer" className="bg-cs-primary hover:bg-cs-primary/90 text-white text-lg px-8 py-6 rounded-md flex items-center gap-2">
              Get 5 sample profiles now. No commitments.
              <ArrowRight className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>
    </section>;
};
export default CTASection;
